module.exports = __webpack_public_path__ + "static/media/loader-token.eb9cea3c.gif";